import { Avatar, Button, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Constants from "../../../data/Constants";
import Skeleton from "react-loading-skeleton";
import {
  deleteMentor,
  getMentorQuestions,
  getSingleMentor,
} from "../../../services/mentor.service";
import Utils from "../../../utils";
import CourseCard from "../../../components/CourseCard";
import ClassCard from "../../../components/ClassCard";
import { MdEdit, MdEventSeat } from "react-icons/md";
import { TbCircleCheck } from "react-icons/tb";
import { IoCheckmarkCircle } from "react-icons/io5";

import { FaRegCalendarAlt } from "react-icons/fa";
import { useConfirm } from "material-ui-confirm";
import EditQuestionDialog from "components/EditQuestionDialog";

function SingleMentor(props) {
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [questions, setQuestions] = useState();
  const [questionState, setQuestionState] = useState(false);
  const { id } = useParams();
  const [status, setStatus] = useState({ loading: false, error: false });
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const res = await getSingleMentor(id);
        if (res) {
          setData(res);
          setProgress(false);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
        setProgress(false);
      }
    }
    async function questions() {
      try {
        const res = await getMentorQuestions(id);
        setQuestions(res);
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
      }
    }
    api();
    questions();
  }, [isRefreshed]);

  const handledeactivateUser = () => {
    confirm({
      title: "Delete User",
      description: "Are you sure you want to delete this User Account?",
    })
      .then(async () => {
        try {
          setProgress(true);
          const res = await deleteMentor(id);
          if (res) {
            setProgress(false);
            setToast({ success: true, message: "Mentor Deleted Successfully" });
          } else {
            // error
            setToast({ error: true, message: Constants.Error.UNKNOWN });
            setProgress(false);
          }
        } catch (error) {
          // error
          console.log(error);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      })
      .catch(() => {});
  };

  return (
    data && (
      <div className="grid">
        <div className="grid grid-cols-3">
          <div className="w-full  flex grid-flow col-span-3 sm:col-span-1 items-center justify-center">
            <Avatar src={data.picture} sx={{ width: 150, height: 150 }} />
          </div>
          <div className="sm:col-span-2 col-span-3  py-5 px-6">
            <h1 className="text-3xl font-extrabold">
              {data.firstname + " " + data.lastname}
            </h1>
            <h1 className="text-sm font-extrabold">{data.profession}</h1>
            <h1 className="text-sm">
              Status: <span className="font-extrabold">{data.status}</span>
            </h1>
            <h1 className="text-sm">
              Email:{" "}
              <span className="font-extrabold">{data.email ?? "Not Set"}</span>
            </h1>
            <h1 className="text-sm">
              Mobile:{" "}
              <span className="font-extrabold">{data.mobile ?? "Not Set"}</span>
            </h1>
            <h1 className="text-sm">
              Counselling:{" "}
              <span className="font-extrabold">
                {data.isCounsellingEnabled ? "Enabled" : "Disabled"}
              </span>
            </h1>

            <h1 className="text-sm">
              Deleted:{" "}
              <span className="font-extrabold">
                {data.deleted ? "True" : "False"}
              </span>
            </h1>

            {data.isCounsellingEnabled && (
              <>
                {" "}
                <h1 className="text-sm">
                  Counselling Cost Price:{" "}
                  <span className="font-extrabold">
                    {Constants.CURRENCY_SYMBOL + data.counsellingCostPrice}
                  </span>
                </h1>
                <h1 className="text-sm">
                  Counselling Sale Price:{" "}
                  <span className="font-extrabold">
                    {Constants.CURRENCY_SYMBOL + data.counsellingSalePrice}
                  </span>
                </h1>
              </>
            )}

            <div className="text-sm my-2 text-gray-600">{data.description}</div>
            <div className="flex gap-2 my-2">
              <Button
                variant="outlined"
                onClick={handledeactivateUser}
                disabled={data.deleted}
              >
                {data.deleted ? "Deleted" : "Delete"}
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  navigate("/dashboard/payouts?mentor=" + id);
                }}
              >
                View Payouts
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  navigate("/dashboard/counselling?mentor=" + id);
                }}
              >
                View Bookings
              </Button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2">
          <div className="my-3">
            <div className="my-2">
              <h1 className="text-xl font-extrabold">Mentor Availability</h1>
              {data.slots == 0 && (
                <div className="my-2 text-gray-800">No Slots</div>
              )}

              {data.slots.map((slot, index) => {
                return (
                  <div className="p-2 text-sm bg-secondary m-2 rounded-sm flex  max-w-lg">
                    <div className="font-bold px-2">SLOT {index + 1}</div>
                    <div>
                      {moment(slot.time).format(Constants.DATE_TIME_FORMAT)}
                    </div>
                    <div className="ml-auto">
                      Duration: {Utils.round(slot.duration / 60) + "hr"}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="my-2">
              <h1 className="text-xl font-extrabold">Carousal Media</h1>
              <div className="my-2 flex gap-4 cursor-pointer overflow-scroll">
                {data.covers == 0 && (
                  <div className="my-2 text-gray-800">No Covers</div>
                )}

                {data.covers &&
                  data.covers.map((media, index) => {
                    if (media.type == "Photo") {
                      return (
                        <img
                          className="w-56 h-32 rounded-xl object-cover"
                          key={index}
                          src={media.url}
                        />
                      );
                    }
                  })}
              </div>
            </div>

            <div className="my-2">
              <h1 className="text-xl font-extrabold">Assigned Classes</h1>
              <div className="my-2 flex gap-4 flex-wrap">
                {data.classes == 0 && (
                  <div className="my-2 text-gray-800">No Classes</div>
                )}
                {data.classes
                  ? data.classes.map((courseClass, index) => {
                      return (
                        <ClassCard courseClass={courseClass} key={index} />
                      );
                    })
                  : null}
              </div>
            </div>

            <div className="my-2">
              <h1 className="text-xl font-extrabold">Assigned Courses</h1>
              <div className="my-2 flex gap-4 cursor-pointer flex-wrap">
                {data.assignedCourses == 0 && (
                  <div className="my-2 text-gray-800">No Courses Assigned</div>
                )}
                {data.assignedCourses
                  ? data.assignedCourses.map((course, index) => {
                      return (
                        <CourseCard
                          course={course}
                          className="cursor-pointer"
                          key={index}
                          hideActionBar
                          onClick={() =>
                            navigate("/dashboard/courses/edit/" + course._id)
                          }
                        />
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
          <div className="mx-2">
            <div className="my-2">
              <h1 className="text-xl font-extrabold">Course Schedule</h1>
              {data.schedule.courses.length == 0 && (
                <div className="my-2 text-gray-800">No Sessions</div>
              )}
              {data.schedule.courses.map((event, index) => {
                const isPast = moment(event.startTime).isBefore();
                return (
                  <div
                    className={
                      "p-2 text-sm m-2 rounded-sm flex items-center max-w-lg " +
                      (isPast ? " bg-green-200 " : " bg-secondary ")
                    }
                  >
                    <div>
                      {isPast ? (
                        <TbCircleCheck size={20} />
                      ) : (
                        <FaRegCalendarAlt size={14} />
                      )}
                    </div>
                    <div className="font-bold px-2">{event.topicName}</div>
                    <div>{event.friendlyTime}</div>
                    <div className="ml-auto">
                      {moment(event.startTime).format("dddd, MMMM Do YYYY")}
                    </div>
                  </div>
                );
              })}{" "}
            </div>

            <div className="my-4">
              <h1 className="text-xl font-extrabold">Counselling Schedule</h1>
              {data.schedule.counselling.length == 0 && (
                <div className="my-2 text-gray-800">No Sessions</div>
              )}
              {data.schedule.counselling.map((event, index) => {
                const isPast = moment(event.startTime).isBefore();
                return (
                  <div
                    className={
                      "p-2 text-sm m-2 rounded-sm flex items-center max-w-lg " +
                      (isPast ? " bg-green-200 " : " bg-secondary ")
                    }
                  >
                    <div>
                      {isPast ? (
                        <TbCircleCheck size={20} />
                      ) : (
                        <FaRegCalendarAlt size={14} />
                      )}
                    </div>
                    <div className="font-bold px-2">
                      {event.mentor.firstname + " " + event.mentor.lastname}
                    </div>
                    <div>{event.friendlyTime}</div>
                    <div className="ml-auto">
                      {moment(event.startTime).format("dddd, MMMM Do YYYY")}
                    </div>
                  </div>
                );
              })}
            </div>

            {questions && (
              <div className="my-4">
                {questions.length == 0 && (
                  <div className="my-2 text-gray-800">No Questions</div>
                )}
                {questions.map((obj, index) => {
                  return (
                    <div
                      className="p-2 text-sm bg-secondary m-2 rounded-sm max-w-lg  items-center"
                      key={index}
                    >
                      <div className="flex gap-2 items-center font-bold">
                        {index + 1}. {obj.question}
                        {obj.userCourse && (
                          <Tooltip title="User has bought the Course">
                            <IoCheckmarkCircle className="text-lg" />
                          </Tooltip>
                        )}
                      </div>
                      <div className="flex items-center">
                        {obj.answer ? "Answered: " + obj.answer : "Unanswered"}
                        {
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setQuestionState(obj);
                            }}
                          >
                            <MdEdit />
                          </IconButton>
                        }
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {questionState && (
          <EditQuestionDialog
            question={questionState}
            onChange={(question) => {
              const temp = [...questions];
              const index = temp.findIndex((q) => q._id == question._id);
              temp[index] = question;
              setQuestions(temp);
            }}
            onClose={() => {
              setQuestionState(false);
            }}
          />
        )}

        {status.loading && (
          <React.Fragment>
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
          </React.Fragment>
        )}
      </div>
    )
  );
}

export default SingleMentor;
